import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[sidebar-menu]'
})
export class SidebarMenuDirective {

  constructor(private el: ElementRef) { }

  @HostListener('click', ['$event']) onClick($event) {
    var windowW = window.innerWidth;
    var page = page = $('#page-container');

    if (windowW > 991) { // Toggle main sidebar in large screens (> 991px)
      page.toggleClass('sidebar-visible-lg');

      if (page.hasClass('sidebar-mini')) {
        page.toggleClass('sidebar-visible-lg-mini');
      }
    } else { // Toggle main sidebar in small screens (< 992px)
      page.toggleClass('sidebar-visible-xs');
    }
  }

}
